// Where a line of Board activity, or its pop-up, goes when clicked (Features 1, 20 Oct), worked out without opening
// anything: goto.ts opens it, loaded on the click.

import type { Activity, ActivityTo } from "../../shared/types";
import { get } from "./store";

/** Where a line goes: what it says, else (a line from before) the widget it names, else nowhere. */
export function targetOf(a: Pick<Activity, "to" | "itemId" | "boardId">): ActivityTo | null {
  if (a.to !== undefined) return a.to;
  return a.itemId && a.boardId ? { board: a.boardId, item: a.itemId } : null;
}

/** The board's name, for "Open" on a line before it is clicked; null when it is gone. */
export function placeName(to: ActivityTo | null | undefined): string | null {
  if (!to) return null;
  const s = get();
  // an archived board opens too, read only
  return (s.boards.find((b) => b.id === to.board) ?? s.archived.find((b) => b.id === to.board))?.name ?? null;
}

/** Opens what a line or a pop-up is about, as a click on it there would. */
export function openPlace(to: ActivityTo): void {
  void import("./goto").then((m) => m.goTo(to));
}
